import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { Route, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { ExportExcelService } from 'src/app/shared/xlsx-view/export-excel.service';

@Component({
  selector: 'app-crown-point-config',
  templateUrl: './crown-point-config.component.html',
  styleUrls: ['./crown-point-config.component.scss']
})
export class CrownPointConfigComponent implements OnInit {
  @Output() pointConfigration: EventEmitter<boolean> = new EventEmitter;
  pointStructureUser: any = []
  campaignDetail: any
  formGroup

  excelFormat: any = {};
  excelArray: any = [];
  excelData: any = [];
  page = 1;
  getPaginationCount;


  constructor(
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private router: Router,
    private exportExcelService: ExportExcelService,
    private modalService: NgbModal,
    private toast: ToastClientService,
    private fb: FormBuilder
  ) { }

  ngOnInit() {
    // this.pointConfigration.emit(true);
    this.campaignDetail = JSON.parse(localStorage.getItem('crown_collection'))

    this.getPointsConfig()
  }

  getPointsConfig() {
    this.apiService.getHeaders(this.apiConfig.getCrownPoints + `?campaign_id=${this.campaignDetail.campaign_id}&page_no=${this.page}`).subscribe((res: any) => {
      console.log(res)
      if (res.body.data.length != 0) {
        this.pointStructureUser = res.body.data.data
        this.getPaginationCount = res.headers.get('X-Pagination-Total-Count')
        if (res.body.data.data.pagination.length != 0) {
          let crown_collection = {
            is_edit: this.campaignDetail.is_edit,
            create: this.campaignDetail.create,
            whitelist: this.campaignDetail.whitelist,
            points_config: 1,
            target: this.campaignDetail.target,
            campaign_id: this.campaignDetail.campaign_id
          }
          localStorage.setItem("crown_collection", JSON.stringify(crown_collection))
          this.pointConfigration.emit(true);
        }
        this.excelData = res.body.data.data.data;
        for (var k in this.excelData[0]) {
          if (typeof this.excelData[k] !== 'function') {
            console.log("Key is " + k.replace(/_/g, ' '));
            this.excelFormat.header = k.replace(/_/g, ' ');
            this.excelFormat.key = k
            this.excelArray.push(JSON.parse(JSON.stringify(this.excelFormat)));
            console.log(this.excelArray)
          }
        }
      }
    })
  }

  DownloadReportExcel() {
    console.log("here", this.excelData, this.excelArray)
    this.exportExcelService.DownloadReportExcel('points_calculation', this.excelData, this.excelArray);
  }

  uploadExcel(id) {
    this.router.navigate(["/hubAdmin/crown-upload-excel/" + id])
  }

  paginationClick(e) {
    console.log(e);
    this.page = e;
    this.getPointsConfig()
  }

  openUpdateRecord(update, data) {
    this.modalService.open(update, {
      centered: true,
      backdrop: "static",
    });

    this.formGroup = this.fb.group({
      id: new FormControl(data.id, []),
      points: new FormControl(data.points, [Validators.required])
    });
  }

  get f() {
    return this.formGroup.controls;
  }

  submitted: boolean = false
  updateRecord(values: any) {
    this.submitted = true;
    if (this.formGroup.invalid) {
      return
    }
    console.log(values)
    let payload = {
      id: values.id,
      point: values.points

    }
    this.apiService.post(this.apiConfig.updateCrownPointStructure, payload).subscribe((res: any) => {
      console.log(res)
      this.toast.Success(res.body.data)
      this.closeModal()
      this.getPointsConfig()
    })
  }

  closeModal() {
    this.modalService.dismissAll()
    this.formGroup.reset()
  }

}
